/* jshint esversion: 6 */
import $ from 'jquery';

let $confirmationForm = null;
$(document).on('click', '.actionConfirmation', function(event) {
    if ($('#actionConfirmationModal').length <= 0) {
        return;
    }

    $confirmationForm = $(this).closest('form');
    $('#modal').modal('hide');
    $('#actionConfirmationModal').modal('show');
});

$(document).on('click', '#actionConfirmationButton', function() {
    $('#actionConfirmationModal').modal('hide');
    if ($confirmationForm === null) {
        return;
    }
    $('#modal').modal('show');
    $confirmationForm.submit();
    $confirmationForm = null;
});

$(document).on('hide.bs.modal', '#actionConfirmationModal', function() {
    $('#modal').modal('show');
});
